// src/components/Admin/UserManager/UserSummaryModal.jsx
/* ====================================================================
   UserSummaryModal.jsx  (닉네임 클릭 → 프로필 요약 모달)
==================================================================== */
import React, { useEffect, useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    CircularProgress, IconButton, Button, Box, Typography,
    useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import UserSummary from '../../MyPage/UserSummary';
import api from '../../../api/axios';

export default function UserSummaryModal({ open, onClose, user }) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [fullUser, setFullUser] = useState(null);
    const [loading, setLoading] = useState(false);

    /* ───────── 데이터 로드 ───────── */
    useEffect(() => {
        if (user && open) {
            setLoading(true);
            api.get(`/api/accounts/management/users/${user.id}/summary/`)
                .then(res => setFullUser(res.data))
                .catch(() => setFullUser(null))
                .finally(() => setLoading(false));
        }
    }, [user, open]);

    if (!user) return null;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={isMobile}
            maxWidth="md"
            fullWidth
            sx={{
                '& .MuiDialog-paper': {
                    maxWidth: isMobile ? '100%' : 720,
                    margin: isMobile ? 0 : 'auto',
                    borderRadius: isMobile ? 0 : 3,
                    px: 2, py: 2,
                },
            }}
        >
            {/* ───── 헤더 1행: X 버튼만 ───── */}
            <DialogTitle sx={{ p: 0 }}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <IconButton onClick={onClose} size="small">
                        <CloseIcon />
                    </IconButton>
                </Box>

                {/* ───── 헤더 2행: 가운데 제목 ───── */}
                <Box sx={{ display: 'flex', justifyContent: 'center', px: 2, pb: 1.5 }}>
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 600,
                            textAlign: 'center',
                            wordBreak: 'break-word',
                        }}
                    >
                        {user.nickname || user.username} — 프로필 요약
                    </Typography>
                </Box>
            </DialogTitle>

            {/* ───── 본문 ───── */}
            <DialogContent sx={{ px: 0 }}>
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
                        <CircularProgress size={28} />
                    </Box>
                ) : fullUser ? (
                    <UserSummary userInfo={fullUser} />
                ) : (
                    <Box sx={{ textAlign: 'center', color: 'text.secondary', py: 3 }}>
                        정보를 불러올 수 없습니다.
                    </Box>
                )}
            </DialogContent>

            {/* ───── 모바일 하단 닫기 버튼 ───── */}
            {isMobile && (
                <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
                    <Button onClick={onClose} variant="outlined" fullWidth>
                        닫기
                    </Button>
                </DialogActions>
            )}
        </Dialog>
    );
}